'use strict';
import React from 'react';

class Footer extends React.Component {

  render() {
    return (
      <footer className="footer-container">
        This is footer
      </footer>
    );
  }

}

export default Footer;



// WEBPACK FOOTER //
// ./components/Footer.js